export default __webpack_public_path__ + "static/media/complaint.bf48404c.png";